module.exports = __webpack_public_path__ + "img/tx.07346d3b.jpg";